module.exports = __webpack_public_path__ + "img/report.89cdbf45.png";